module.exports = __webpack_public_path__ + "img/google-play.7c782f39.svg";